import { Box, CssBaseline, Grid, Paper, TableContainer, styled } from "@material-ui/core";
import { Alert, Backdrop, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, Skeleton, Snackbar, Stack, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TextField, Toolbar, Tooltip } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { API_URL } from "../../Constants";
import {API_CLOUD} from "../../Constants";
import EditIcon from '@mui/icons-material/Edit'
import Modal from "../modal/Modal";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { axiosClient } from "../AxiosClient";
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useNavigate } from "react-router-dom";
import { axiosClientCloud } from "../AxiosClient";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const ButtonAdd = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px !important',
    gap: '10px !important',
    backgroundColor: '#161e55 !important',
    color: '#ffff !important',
    margin: '0px 1rem !important',
    '&:hover': {
        backgroundColor: '#A8C8AF !important',
    },
})

const ButtonClientEdit = styled(Button)({
    color: 'black'
})

const ButtonEdit = styled(Button)({
    color: '#161e55',
    '&:hover': {
        color: '#A8C8AF'
    }
})

const titles = ["Nombre", "Documento", "Contacto", "Dirección", ""];
const urlApi = API_URL;

export default function Clientes() {
    const [data, setData] = useState();
    const [dataPage, setDataPage] = useState()
    const [numberPage, setNumberPage] = useState(0);
    const rowsPerPage = 10;
    const [dataClient, setDataClient] = useState();
    const [modalEdit, setModalEdit] = useState(false);
    const [nameEdit, setNameEdit] = useState("");
    const [lastNameEdit, setLastNameEdit] = useState("");
    const [documentTypeEdit, setDocumentTypeEdit] = useState("");
    const [numberDocumentEdit, setNumberDocumentEdit] = useState("");
    const [cellphoneEdit, setCellphoneEdit] = useState("");
    const [addressEdit, setAddressEdit] = useState("");
    const [cityEdit, setCityEdit] = useState("");
    const typeDocument = ['NIT','CC','CE'];
    const [openBackdropEdit, setOpenBackdropEdit] = useState(false);
    const [openSnackbarEdit, setOpenSnackbarEdit] = useState(false);
    const [editClient, setEditClient] = useState();
    const [severity, setSeverity] = useState("");
    const [messageEdit, setMessageEdit] = useState("");
    const [clientUuid, setClientUuid] = useState();
    const clientTypes = ['NATURAL', 'JURIDIDCO'];
    const occupationSectors = ['AGRICULTURA', 'GANADERIA', 'MINERIA', 'MANUFACTURA', 'CONSTRUCCION', 'COMERCIO', 'SERVICIOS_FINANCIEROS', 'ENERGIA', 'TRANSPORTE_LOGISTICA', 'OTROS'];
    const segmentations = [
        {
            name: "Cliente nuevo",
            value: "NEW_CLIENT"
        },
        {
            name: "Cliente finalizado",
            value: "FINISHED_CLIENT"
        },
        {
            name: "Cliente activo",
            value: "ACTIVE_CLIENT"
        },
        {
            name: "Cliente consultado",
            value: "CONSULTED_CLIENT"
        }
    ]
    const occupationTypes = ['INDEPENDIENTE', 'PENSIONADO', 'EMPLEADO'];
    const [placeExpeditionEdit, setPlaceExpeditionEdit] = useState("");
    const [expeditionEdit, setExpeditionEdit] = useState();
    const [placeBirthEdit, setPlaceBirthEdit] = useState("");
    const [rangeAgeEdit, setRangeAgeEdit] = useState("");
    const [correoEdit, setCorreoEdit] = useState("");
    const [genderEdit, setGenderEdit] = useState("");
    const [incomesEdit, setIncomesEdit] = useState("");
    const [otherCellphoneEdit, setOtherCellphoneEdit] = useState("");
    const [typeClientEdit, setTypeEditClient] = useState("");
    const [occupation, setOccupation] = useState("");
    const [descriptionOccupation, setDescriptionOccupation] = useState("");
    const [sectorOccupation, setSectorOccupation] = useState();
    const [occupationType, setOccupationType] = useState();
    const [experian, setExperian] = useState("");
    const [segmentation, setSegmentation] = useState("");
    const [searcher, setSearcher] = useState();
    const [importer, setImporter] = useState(false);
    const importerClient = useRef(null);
    const importerViability = useRef(null);
    const [isImporter, setIsImporter] = useState(false);
    const [viability, setViability] = useState(false);
    const navigation = useNavigate();

    useEffect(() => {
        axiosClient.get('/v1/clients', {
            params: {
                search: searcher ? `fullName:'*${searcher.replace(" ", "+")}*' OR documentNumber:'*${searcher}*'` : '',
                size: rowsPerPage,
                page: numberPage
            }
        })
        .then(response => {
            setData(response.data);
            setDataPage(response.data.content);
        })
        .catch(error => {
            if (error.response) {
                console.log("Error with Axios");
            } else {
                console.log("Bad request: " + error.message);
            }
        });
    }, [editClient])

    const handleChangePage = (event, newPage) => {
        setNumberPage(newPage)
        axiosClient.get('/v1/clients', {
            params: {
                search: searcher ? `fullName:'*${searcher.replace(" ", "+")}*' OR documentNumber:'*${searcher}*'` : '',
                size: rowsPerPage,
                page: newPage
            }
        })
        .then(response => {
            setData(response.data);
            setDataPage(response.data.content);
        })
        .catch(error => {
            if (error.response) {
                console.log("Error with Axios");
            } else {
                console.log("Bad request: " + error.message);
            }
        });
    }

    const handleButton = () => {
        setNumberPage(0)
        axiosClient.get('/v1/clients', {
            params: {
                search: searcher ? `fullName:'*${searcher.replace(" ", "+")}*' OR documentNumber:'*${searcher.replace(" ", "+")}*'` : '',
                size: rowsPerPage,
                page: 0
            }
        })
        .then(response => {
            setData(response.data);
            setDataPage(response.data.content);
        })
        .catch(error => {
            if (error.response) {
                console.log("Error with Axios");
            } else {
                console.log("Bad request: " + error.message);
            }
        });
    }

    const handleEdit = (clientUuid) => {
        setClientUuid(clientUuid)
        axiosClientCloud.get(`/v1/clients/${clientUuid}`)
        .then(response => {
            const res = response.data;
            console.log(res);
            
            setDataClient(res);
            setNameEdit(res.name);
            setLastNameEdit(res.lastName);
            setDocumentTypeEdit(res.documentType);
            setNumberDocumentEdit(res.documentNumber);
            setCellphoneEdit(res.cellphone);
            setAddressEdit(res.address);
            setCityEdit(res.cityAddress);
            setPlaceExpeditionEdit(res.documentExpeditionPlace);
            
            const strings = res?.dateExpedition?.split("/");
            console.log(strings ? new Date(parseInt(strings[2]), parseInt(strings[1], 10) - 1, parseInt(strings[0])) : null);
            setExpeditionEdit(strings ? dayjs(`${strings[2]}-${strings[1]}-${strings[0]}`) : null);
            
            setPlaceBirthEdit(res.placeOfBirth);
            setRangeAgeEdit(res.ageRange);
            setCorreoEdit(res.email);
            setGenderEdit(res.gender);
            setIncomesEdit(res.estimatedIncome);
            setOtherCellphoneEdit(res.secondaryCellphone);
            setOccupation(res.occupation);
            setTypeEditClient(res.type);
            setDescriptionOccupation(res.occupationDescription);
            setSectorOccupation(res.occupationSector);
            setOccupationType(res.occupationClient);
            setExperian(res.incomesExperian);
            
            const string = segmentations.find(segmentation => segmentation.value === res.segmentation);
            console.log(string);
            setSegmentation(string ? string.name : null);
        })
        .catch(error => {
            if (error.response) {
                console.log('Error with Axios');
            } else {
                console.log('Error: ' + error.message);
            }
        });
        setModalEdit(true)
    }

    const handleChangeNameEdit = (event) => {
        setNameEdit(event.target.value)
    }

    const handleChangeLastNameEdit = (event) => {
        setLastNameEdit(event.target.value)
    }

    const handleChangeDocumentTypeEdit = (event) => {
        setDocumentTypeEdit(event.target.value)
    }

    const handleChangeNumberDocumentEdit = (event) => {
        setNumberDocumentEdit(event.target.value)
    }

    const handleChangeCellphoneEdit = (event) => {
        setCellphoneEdit(event.target.value)
    }

    const handleChangeAddressEdit = (event) => {
        setAddressEdit(event.target.value)
    }

    const handleChangeCityEdit = (event) => {
        setCityEdit(event.target.value)
    }

    const handleChangePlaceExpeditionEdit = (event) => {
        setPlaceExpeditionEdit(event.target.value)
    }

    const handleChangeExpedition = (value) => {
        setExpeditionEdit(value)
    }

    const handleChangePlaceOfBirth = (event) => {
        setPlaceBirthEdit(event.target.value)
    }

    const handleChangeRangeAgeEdit = (event) => {
        setRangeAgeEdit(event.target.value)
    }

    const handleChangeCorreo = (event) => {
        setCorreoEdit(event.target)
    }

    const handleChangeGender = (event) => {
        setGenderEdit(event.target.value)
    }

    const handleChangeIncomes = (event) => {
        setIncomesEdit(event.target.value)
    }

    const handleChangeOtherCellphoneEdit = (event) => {
        setOtherCellphoneEdit(event.target.value)
    }

    const handleChangeTypeClientEdit = (event) => {
        setTypeEditClient(event.target.value)
    }

    const handleChangeOccupation = (event) => {
        setOccupation(event.target.value)
    }

    const handleChangeDescriptionOccupationEdit = (event) => {
        setDescriptionOccupation(event.target.value)
    }

    const handleChangeSectorOccupationEdit = (event) => {
        setSectorOccupation(event.target.value)
    }

    const handleChangeTypeOccupationEdit = (event) => {
        setOccupationType(event.target.value)
    }

    const handleChangeExperian = (event) => {
        setExperian(event.target.value)
    }

    const handleChangeSegmentation = (event) => {
        setSegmentation(event.target.value)
    }

    const handleChangeClient = (event) => {
        setSearcher(event.target.value)
    }

    const handleClosedModalEdit = () => {
        setModalEdit(!modalEdit)
        setNameEdit("")
        setLastNameEdit("")
        setDocumentTypeEdit("")
        setNumberDocumentEdit("")
        setCellphoneEdit("")
        setAddressEdit("")
        setCityEdit("")
        setClientUuid("")
        setPlaceExpeditionEdit("")
        setExpeditionEdit(null)
        setPlaceBirthEdit("")
        setRangeAgeEdit("")
        setCorreoEdit("")
        setGenderEdit("")
        setIncomesEdit("")
        setOtherCellphoneEdit("")
        setTypeEditClient("")
        setOccupation("")
        setDescriptionOccupation("")
        setSectorOccupation("")
        setOccupationType("")
        setExperian("")
        setSegmentation("")
    }

    const handleEditClient = (event) => {
        event.preventDefault();
        setOpenBackdropEdit(true)
        const body = {
            name: nameEdit,
            lastName: lastNameEdit,
            documentType: documentTypeEdit=="" ? 'CC' : documentTypeEdit,
            documentNumber: numberDocumentEdit,
            cellphone: cellphoneEdit,
            address: addressEdit,
            cityAddress: cityEdit,
            documentExpeditionPlace: placeExpeditionEdit,
            dateExpedition: expeditionEdit ? dayjs(`${expeditionEdit?.$d?.getFullYear()}-${expeditionEdit?.$d?.getMonth()+1}-${expeditionEdit?.$D}`).format('DD/MM/YYYY') : null,
            placeOfBirth: placeBirthEdit,
            ageRange: rangeAgeEdit,
            email: correoEdit,
            gender: genderEdit,
            estimatedIncome: incomesEdit,
            secondaryCellphone: otherCellphoneEdit,
            type: typeClientEdit,
            occupation: occupation,
            occupationDescription: descriptionOccupation,
            occupationSector: sectorOccupation,
            occupationClient: occupationType,
            incomesExperian: experian,
            segmentation: segmentation ? segmentations.filter(type => type.name == segmentation)[0].value : null
        }
        axiosClientCloud.patch(`/v1/clients/${clientUuid}`, body, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            handleClosedModalEdit();
            setOpenBackdropEdit(false);
            setOpenSnackbarEdit(true);
            setMessageEdit("Se editó exitosamente el cliente");
            setTimeout(() => setSeverity("success"), 5000);
            setEditClient(clientUuid);
        })
        .catch(error => {
            setOpenBackdropEdit(false);
            setOpenSnackbarEdit(true);
            setMessageEdit("Error en la edición del cliente");
            setSeverity("error");
            console.log('Error: ' + error.message);
        });
    }

    const handleClosedSnackEdit = (event, reason) => {
        if(reason == 'clickaway'){
            return;
        }
        setOpenSnackbarEdit(false)
    }

    const handleImporter = () => {
        setImporter(!importer);
        if(isImporter) {
            setIsImporter(false);
        }
        if(viability) {
            setViability(false);
        }
    }

    const sendImporter = () => {
        if(importerClient.current?.files?.length > 0) {
            setIsImporter(true);
        } else {
            setIsImporter(false);
        }
        if(importerViability.current?.files?.length > 0) {
            setViability(true);
        } else {
            setViability(false);
        }
    }

    const submitImporter = () => {
        if(importerClient.current?.files?.length > 0) {
            const importClients = new FormData();
            importClients.append('file', importerClient.current?.files[0]);

            axiosClient.post('/v1/importer/clients/update-data', importClients, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                if (response.status === 200) {
                    setSeverity("success");
                    setOpenSnackbarEdit(true);
                    setMessageEdit("Se ha cargado exitosamente la información de los clientes");
                    handleImporter();
                } else {
                    setOpenBackdropEdit(true);
                    setSeverity("error");
                    setOpenSnackbarEdit(true);
                    setMessageEdit("Ha ocurrido un error al guardar la información de los clientes, por favor verifica la información y vuelve a intentarlo");
                }
            })
            .catch(error => {
                setOpenBackdropEdit(true);
                setSeverity("error");
                setOpenSnackbarEdit(true);
                setMessageEdit("Ha ocurrido un error al guardar la información, por favor verifica la información y vuelve a intentarlo");
                console.log('Error: ' + error.message);
            });
        }

        if(importerViability.current?.files?.length > 0) {
            const importViabilities = new FormData();
            importViabilities.append("file", importerViability.current?.files[0]);
            axiosClient.post('/v1/importer/viabilities-study', importViabilities)
            .then(response => {
                setSeverity("success");
                setOpenSnackbarEdit(true);
                setMessageEdit("Se ha cargado exitosamente la información de las viabilidades");
                handleImporter();
            })
            .catch(error => {
                setOpenBackdropEdit(true);
                setSeverity("error");
                setOpenSnackbarEdit(true);
                setMessageEdit("Ha ocurrido un error al guardar la información de las viabilidades, por favor verifica la información y vuelve a intentarlo");
            });
        }
    }

    const handleDocumentos = (clientUuid) => {
        navigation(`/homeAdmin/documentos/clientes/${clientUuid}`);
    }

    return (
        <React.Fragment>
            <CssBaseline></CssBaseline>
            <Toolbar></Toolbar>
            <Box sx={{width: '100%', margin: '18px 14px'}}>
                <Stack spacing={2}>
                    <Item>.</Item>
                    <Item></Item>
                    <Grid container>
                        <Grid item xs={6}>
                            <Box mt={2} sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <h1>Clientes</h1>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <ButtonAdd onClick={() => navigation('/homeAdmin/viability-study-by-document')}>Generar estudio viabilidad</ButtonAdd>
                                    <ButtonAdd onClick={handleImporter}>Importar</ButtonAdd>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                                <Box mt={2} sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    <Box >
                                        <FormControl fullWidth>
                                            <TextField id="buscar" label="Palabra clave" variant="outlined" value={searcher} onChange={handleChangeClient}></TextField>
                                        </FormControl>
                                    </Box>
                                    <Box>
                                        <ButtonAdd onClick={handleButton}>Buscar</ButtonAdd>
                                    </Box>
                                </Box>
                            </Grid>
                    </Grid>
                    <Grid container>
                        <TableContainer component={Paper}>
                            <Table sx={{minWidth: 650}} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        {titles.map(title => (
                                            <TableCell key={title} align="center">{title}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dataPage ? dataPage.map(client => (
                                        <TableRow key={client.uuid} sx={{'&:last-child td, &:last-child th': { border: 0 }}}>
                                            <TableCell align="center">{`${client.name} ${client.lastName}`}</TableCell>
                                            <TableCell align="center">{`${client.documentType} ${client.documentNumber}`}</TableCell>
                                            <TableCell align="center">{client.cellphone}</TableCell>
                                            <TableCell align="center">
                                                {`${client.cityAddress}`}
                                                <br/>
                                                {`${client.address}`}
                                            </TableCell>
                                            <TableCell align="center">
                                                <ButtonEdit onClick={() => handleEdit(client.uuid)}><EditIcon></EditIcon></ButtonEdit>
                                                <Tooltip title="Ver documentos">
                                                    <ButtonEdit onClick={() => handleDocumentos(client.uuid)}><AssignmentIcon></AssignmentIcon></ButtonEdit>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    )) : <TableRow>
                                            <TableCell>
                                                <Skeleton variant="rounded" animation="wave"></Skeleton>
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton variant="rounded" animation="wave"></Skeleton>
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton variant="rounded" animation="wave"></Skeleton>
                                            </TableCell>
                                            <TableCell>
                                                <Box sx={{display: 'flex', flexDirection: 'column' ,gap: '8px'}}>
                                                    <Skeleton variant="rounded" animation="wave"></Skeleton>
                                                    <Skeleton variant="rounded" animation="wave"></Skeleton>
                                                </Box>
                                            </TableCell>
                                        </TableRow>}
                                </TableBody>
                            </Table>
                            <TablePagination
                            rowsPerPageOptions={[rowsPerPage]}
                            count={(data?.totalElements)}
                            rowsPerPage={rowsPerPage}
                            page={numberPage}
                            onPageChange={handleChangePage}
                            />
                        </TableContainer>
                    </Grid>
                </Stack>
            </Box>
            {modalEdit && 
                <Modal activeModal={modalEdit} handleModal={handleClosedModalEdit}>
                    <Box textAlign={'center'}>
                        <h2>Modificación de clientes</h2>
                    </Box>
                    <Box width={'80%'} margin={'1rem auto'}>
                        <form onSubmit={handleEditClient}>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="name" label="Nombre" variant="outlined" value={nameEdit} onChange={handleChangeNameEdit}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="lastName" label="Apellido" variant="outlined" value={lastNameEdit} onChange={handleChangeLastNameEdit}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <InputLabel id="tipo-documento">Tipo de documento</InputLabel>
                                    <Select labelId="tipo-documento" id="tipoDocumento" label="Tipo de documento" value={documentTypeEdit} onChange={handleChangeDocumentTypeEdit}>
                                        {typeDocument.map(tipoDocument => (
                                            <MenuItem key={tipoDocument} value={tipoDocument}>{tipoDocument}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="numberDocument" label="Número de documento" variant="outlined" value={numberDocumentEdit} onChange={handleChangeNumberDocumentEdit}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="document-expedition-place" label="Lugar expedición documento" variant="outlined" value={placeExpeditionEdit} onChange={handleChangePlaceExpeditionEdit}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                            <Box width={'100%'} mb={2}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker label="Fecha expedición documento" value={expeditionEdit} onChange={handleChangeExpedition}></DatePicker>
                                    </LocalizationProvider>
                                </FormControl>
                            </Box>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="cellphone" label="Número de contacto" variant="outlined" value={cellphoneEdit} onChange={handleChangeCellphoneEdit}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="address" label="Dirección" variant="outlined" value={addressEdit} onChange={handleChangeAddressEdit}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="city" label="Ciudad de residencia" variant="outlined" value={cityEdit} onChange={handleChangeCityEdit}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="place-of-birth" label="Lugar de nacimiento" variant="outlined" value={placeBirthEdit} onChange={handleChangePlaceOfBirth}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="age" label="Edad o rango de edad" variant="outlined" value={rangeAgeEdit} onChange={handleChangeRangeAgeEdit}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="email" label="Correo" variant="outlined" value={correoEdit} onChange={handleChangeCorreo}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="gender" label="Género" variant="outlined" value={genderEdit} onChange={handleChangeGender}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="incomes" label="Ingresos estimados" variant="outlined" value={incomesEdit} onChange={handleChangeIncomes}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="other-cellphone" label="Celular secundario" variant="outlined" value={otherCellphoneEdit} onChange={handleChangeOtherCellphoneEdit}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <InputLabel id="client-type">Tipo cliente</InputLabel>
                                    <Select labelId="client-type" id="tipoCliente" label="Tipo cliente" value={typeClientEdit} onChange={handleChangeTypeClientEdit}>
                                        {clientTypes.map(clientType => (
                                            <MenuItem key={clientType} value={clientType}>{clientType}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="occupation" label="Ocupación" variant="outlined" value={occupation} onChange={handleChangeOccupation}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="occupation-description" label="Descripción ocupación" variant="outlined" value={descriptionOccupation} onChange={handleChangeDescriptionOccupationEdit}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <InputLabel id="occupation-sector">Sector de ocupación</InputLabel>
                                    <Select labelId="occupation-sector" id="sectorOcupacion" label="Sector de ocupación" value={sectorOccupation} onChange={handleChangeSectorOccupationEdit}>
                                        {occupationSectors.map(occupationSector => (
                                            <MenuItem key={occupationSector} value={occupationSector}>{occupationSector}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <InputLabel id="occupation-type">Tipo de ocupación</InputLabel>
                                    <Select labelId="occupation-type" id="tipoOcupacion" label="Tipo de ocupación" value={occupationType} onChange={handleChangeTypeOccupationEdit}>
                                        {occupationTypes.map(occupationType => (
                                            <MenuItem key={occupationType} value={occupationType}>{occupationType}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="income" label="Ingresos Experian" variant="outlined" value={experian} onChange={handleChangeExperian}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <InputLabel id="segmentation">Segmentación</InputLabel>
                                    <Select labelId="segmentation" id="segmentations" label="Segmentación" value={segmentation} onChange={handleChangeSegmentation}>
                                        {segmentations.map(segmentation => (
                                            <MenuItem key={segmentation.name} value={segmentation.name}>{segmentation.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box mt={2} textAlign={'center'}>
                                <ButtonAdd type="submit">Editar cliente</ButtonAdd>
                            </Box>
                        </form>
                    </Box>
                </Modal>
            }
            { importer &&
                <Modal activeModal={importer} handleModal={handleImporter}>
                <Box textAlign={'center'}>
                    <h2>Importar clientes y estudio de viabilidades</h2>
                </Box>
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', flexDirection: 'column', height: '60%'}}>
                    <Box mt={5} mb={2} display={'flex'} alignItems={'center'} border={'1px solid gray'} justifyContent={'space-between'} padding={'1rem'} borderRadius={'1rem'} width={'85%'}>
                        <InputLabel id="document">Archivo CSV con información clientes</InputLabel>
                        <ButtonAdd onClick={(e) => importerClient.current?.click()}>
                            <input accept='.csv' type='file' multiple hidden ref={importerClient} onChange={sendImporter}></input>
                            Subir documento
                        </ButtonAdd>
                    </Box>
                    {isImporter && 
                        <p>Documento cargado</p>
                    }
                    <Box mt={5} mb={2} display={'flex'} alignItems={'center'} border={'1px solid gray'} justifyContent={'space-between'} padding={'1rem'} borderRadius={'1rem'} width={'85%'}>
                        <InputLabel id="document">Archivo CSV con información viabilidades</InputLabel>
                        <ButtonAdd onClick={(e) => importerViability.current?.click()}>
                            <input accept='.csv' type='file' multiple hidden ref={importerViability} onChange={sendImporter}></input>
                            Subir documento
                        </ButtonAdd>
                    </Box>
                    {viability && 
                        <p>Documento cargado</p>
                    }
                    <Box sx={{display: 'flex', justifyContent: 'center', gap: '1rem'}}>
                        <ButtonAdd onClick={submitImporter}>Cargar</ButtonAdd>
                    </Box>
                </Box>
            </Modal>
            }
            <Backdrop sx={{background: 'rgba(255,255,255,0.1)', zIndex: '5', width: '50%', margin: 'auto auto auto 30vw'}} open={openBackdropEdit}>
                <CircularProgress color="success" />
            </Backdrop>
            <Snackbar open={openSnackbarEdit} autoHideDuration={5000} onClose={handleClosedSnackEdit}>
                <Alert onClose={handleClosedSnackEdit} severity={severity} sx={{width: '100%'}}>{messageEdit}</Alert>
            </Snackbar>
        </React.Fragment>
    )
}